import type { Settlement } from '../engine/map/settlement';
import { getGameConfig } from '../config/gameConfig';
import { runCooperativeProductionTick } from './genericProduction';

export function runSawmillTick(settlement: Settlement): boolean {
    const config = getGameConfig();
    const result = runCooperativeProductionTick(
        settlement,
        'sawmill',
        settlement.jobs.sawmillers,
        config.production.sawmillWorkPerBatch,
        settlement.production.sawmill.work,
    );
    settlement.production.sawmill.work = result.work;
    return result.changed;
}
